import { getBaseDomain } from '../../../../utils/route'

// Absolute URLs only: a relative redirect target is not a cross-host redirect and
// keeps the SPA navigation; an unparsable one falls back the same way.
export function isSameBaseDomainRedirectUrl(url) {
  try {
    return (
      getBaseDomain(new URL(url).hostname) ===
      getBaseDomain(window.location.hostname)
    )
  } catch {
    return false
  }
}
